export const getUserGroupInvitation = async (url, token) => {
  try {
    const result = await fetch(url + '/group-invitation/user-group-invitation', {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token,
        'Content-Type': 'application/json'
      },
    });

    const resData = await result.json();

    console.log(result, resData);
    // dispatch('SET_TALKPERMISSION', resData.data);

    if (!result.ok) {
      throw new Error('error occured');
    }

    return resData;
  } catch(err) {
    console.log(err);
    throw err;
  }
};

export const getGroupInvitationData = async (url, token, groupRoomId) => {
  try {
    const result = await fetch(url + `/group-invitation/group-invitation-data?groupRoomId=${groupRoomId}`, {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token,
        'Content-Type': 'application/json'
      },
    });

    const resData = await result.json();

    console.log(result, resData);
    // dispatch('SET_TALKPERMISSION', resData.data);

    if (!result.ok) {
      throw new Error('error occured');
    }

    return resData;
  } catch(err) {
    console.log(err);
    throw err;
  }
};


export const acceptGroupInvitation = async (
  url, 
  token,
  groupRoomId,
) => {
  try {
    const result = await fetch(url + '/group-invitation/accept-group-invitation', {
      method: 'PUT',
      headers: {
        Authorization: 'Bearer ' + token,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        groupRoomId: groupRoomId,
      }),
    });

    const resData = await result.json();

    console.log(result, resData);
    // dispatch('SET_TALKPERMISSION', resData.data);

    if (!result.ok) {
      throw new Error('error occured');
    }

    return resData;
  } catch(err) {
    console.log(err);
    throw err;
  }
};

export const acceptGroupInvitationQR = async (
  url, 
  token,
  qrToken,
  // userId,
  // email,
) => {
  try {
    const result = await fetch(url + '/group-invitation/accept-group-invitation-qr', {
      method: 'PUT',
      headers: {
        Authorization: 'Bearer ' + token,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        qrToken: qrToken,
        // userId: userId,
        // email: email,
        // groupRoomId: groupRoomId,
      }),
    });

    const resData = await result.json();

    console.log(result, resData);
    // dispatch('SET_TALKPERMISSION', resData.data);

    if (!result.ok) {
      throw new Error('error occured');
    }

    return resData;
  } catch(err) {
    console.log(err);
    throw err;
  }
};

export const addGroupInvitation = async (
  url, 
  token,
  groupRoomId,
  email,
) => {
  try {
    const result = await fetch(url + '/group-invitation/add-group-invitation', {
      method: 'PUT',
      headers: {
        Authorization: 'Bearer ' + token,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        groupRoomId: groupRoomId,
        email: email,
      }),
    });

    const resData = await result.json();

    console.log(result, resData);
    // dispatch('SET_TALKPERMISSION', resData.data);

    if (!result.ok) {
      throw new Error('error occured');
    }

    return resData;
  } catch(err) {
    console.log(err);
    throw err;
  }
};


export const cancelGroupInvitation = async (
  url, 
  token,
  groupRoomId,
  email,
) => {
  try {
    const result = await fetch(url + '/group-invitation/cancel-group-invitation', {
      method: 'PUT',
      headers: {
        Authorization: 'Bearer ' + token,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        groupRoomId: groupRoomId,
        email: email,
      }),
    });

    const resData = await result.json();

    console.log(result, resData);
    // dispatch('SET_TALKPERMISSION', resData.data);

    if (!result.ok) {
      throw new Error('error occured');
    }

    return resData;
  } catch(err) {
    console.log(err);
    throw err;
  }
};


export const deleteUserFromGroupMembers = async (
  url, 
  token,
  groupRoomId,
  userId,
) => {
  try {
    const result = await fetch(url + '/group-invitation/delete-user-from-group-members', {
      method: 'PUT',
      headers: {
        Authorization: 'Bearer ' + token,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        groupRoomId: groupRoomId,
        userId: userId,
      }),
    });

    const resData = await result.json();

    console.log(result, resData);
    // dispatch('SET_TALKPERMISSION', resData.data);

    if (!result.ok) {
      throw new Error('error occured');
    }

    return resData;
  } catch(err) {
    console.log(err);
    throw err;
  }
};


export const updateGroupInvitationLastOpenAt = async (
  url, 
  token,
) => {
  try {
    const result = await fetch(url + '/group-invitation/last-open-at', {
      method: 'PUT',
      headers: {
        Authorization: 'Bearer ' + token,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({}),
    });

    const resData = await result.json();

    console.log(result, resData);
    // dispatch('SET_TALKPERMISSION', resData.data);

    if (!result.ok) {
      throw new Error('error occured');
    }

    return resData;
  } catch(err) {
    console.log(err);
    throw err;
  }
};